import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";
import {ProductBarcodeSearchModel} from "../product-barcode-search.model";
import {ProductBarcodeEntityModel} from "../product-barcode-entity.model";

@Component({
    selector: "wbo-product-barcode-search-page",
    templateUrl: "./product-barcode-search-page.component.html",
    providers: [provideSearchModel(ProductBarcodeSearchModel), provideEntityModel(ProductBarcodeEntityModel)]
})
export class ProductBarcodeSearchPageComponent extends AbstractSearchPage {

    constructor() {
        super();
    }
}
